
import { Progress, Table } from 'antd';

const { Column, ColumnGroup } = Table;


const formatProgress = (percent) => {
  const total = 4;
  const completed = Math.round((percent / 100) * total);
  return `${completed}/${total}`;
};

const libraryScheduleItemData = [
  {
    key: 1,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Friday April 28th 2023',
    due_date: 'Apr 28'
  },
  {
    key: 2,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Friday April 28th 2023',
    due_date: 'Apr 28'
  },
  {
    key: 3,
    firstName: '1841 Easton',
    workflow: 'Property Listing',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'

  },
  {
    key: 4,
    firstName: '1000 ne 7',
    workflow: 'Move In',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'

  },
  {
    key: 5,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'Turn off utilities',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 6,
    firstName: '1841 Easton',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'


  },
  {
    key: 7,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'


  },
  {
    key: 8,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27',
  },
  {
    key: 9,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'
  },
  {
    key: 10,
    firstName: '1841 Easton',
    workflow: 'Property Listing',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 11,
    firstName: '1000 ne 7',
    workflow: 'Move In',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Overdue'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 12,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'Turn off utilities',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 13,
    firstName: '1841 Easton',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'


  },
  {
    key: 14,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'


  },
  {
    key: 15,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Tuesday April 30th 2023',
    due_date: 'Apr 30'
  },
  {
    key: 16,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Tuesday April 30th 2023',
    due_date: 'Apr 30'
  },
  {
    key: 17,
    firstName: '1841 Easton',
    workflow: 'Property Listing',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 18,
    firstName: '1000 ne 7',
    workflow: 'Move In',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 19,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'Turn off utilities',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Wednesday April 26th 2023',
    due_date: 'Apr 26'

  },
  {
    key: 20,
    firstName: '1841 Easton',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'


  },
  {
    key: 21,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'


  },
  {
    key: 22,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'
  },
  {
    key: 23,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'
  },
  {
    key: 24,
    firstName: '1841 Easton',
    workflow: 'Property Listing',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    start_date: 'Wednesday April 26th 2023',
    due_date: 'Apr 26'

  },
  {
    key: 25,
    firstName: '1000 ne 7',
    workflow: 'Move In',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Overdue'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'

  },
  {
    key: 26,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'Turn off utilities',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'

  },
  {
    key: 27,
    firstName: '1841 Easton',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'


  },
  {
    key: 28,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Wednesday April 26th 2023',
    due_date: 'Apr 26'


  },
  {
    key: 29,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'
  },
  {
    key: 30,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'
  },
  {
    key: 31,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Thursday April 27th 2023',
    due_date: 'Apr 27'
  },
  {
    key: 32,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Friday April 28th 2023',
    due_date: 'Apr 28'
  },
  {
    key: 33,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Friday April 28th 2023',
    due_date: 'Apr 28'
  },
  {
    key: 34,
    firstName: '1841 Easton',
    workflow: 'Property Listing',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    start_date: 'Friday April 28th 2023',
    due_date: 'Apr 28'

  },
  {
    key: 35,
    firstName: '1000 ne 7',
    workflow: 'Move In',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Overdue'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 36,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'Turn off utilities',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'

  },
  {
    key: 37,
    firstName: '1841 Easton',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'


  },
  {
    key: 38,
    firstName: 'BPA 120',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['Due-Soon'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'


  },
  {
    key: 39,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: '2. Make Ready',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>RE</span>,
    tags: ['On-Track'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'
  },
  {
    key: 40,
    firstName: '2701 NW 16th ST Maschino, Logan',
    workflow: 'SD refund',
    assignees: <span style={{
      borderRadius: '50%', padding: '6px 5px', color: 'white',
      backgroundColor: '#dddddd'
    }}>CH</span>,
    tags: ['On-Track'],
    start_date: 'Monday April 29th 2023',
    due_date: 'Apr 29'
  },
];

export default libraryScheduleItemData;